export const ENUM__string_id_empty = {
  HASH_SHA256: `sha256:${'0'.repeat(64)}`,
  HASH_SHA256_WITHOUT_PROTOCOL: `${'0'.repeat(64)}`,
  //
  HASH_MD5: `md5:${'0'.repeat(32)}`,
  //
  OBJECT_ID_WITH_PROTOCOL: `object_id:${'0'.repeat(24)}`,
  OBJECT_ID: `${'0'.repeat(24)}`,

  UUID_WITHOUT_PROTOCOL: '00000000-0000-0000-0000-000000000000',

  UUID: 'uuid:00000000-0000-0000-0000-000000000000',

  ML_ASSET_VERSION: '0.0',
};
